import React from "react";

import {
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";

export default function TimelinePopover<T>({
  triggerComponent: TriggerComponent,
  children,
  items,
}: {
  items: T[];
  triggerComponent: React.ReactNode;
  children:
    | ((props: T & { index: number }) => React.ReactNode)
    | React.ReactElement<T & { index: number }>;
}) {
  return (
    <Popover>
      <PopoverTrigger>{TriggerComponent}</PopoverTrigger>
      <PopoverContent minW="sm">
        <PopoverBody display="flex" position="relative">
          <Flex direction="column">
            {items.map((item, index) =>
              typeof children === "function"
                ? children({ ...item, index })
                : children
            )}
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
